import * as React from 'react';
import { Label, TooltipDesktop } from '@cian/ui-kit';

const PARTNER_TOOLTIP_TEXT = 'Партнёр Циана по контролю качества объявлений';

export interface IPartnerTooltipProps {
  /** Кастомный триггер. Если не передан — рисуется ui-kit Label «Партнёр». */
  master?: React.ReactElement;
}

export const PartnerTooltip = ({ master }: IPartnerTooltipProps) => (
  <TooltipDesktop title={PARTNER_TOOLTIP_TEXT} theme="white" placement="bottom-start">
    {master ?? (
      <Label background="accent-positive-secondary" color="accent-positive-primary">
        Партнёр
      </Label>
    )}
  </TooltipDesktop>
);
